import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from "../../_models/globals";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-settings-drivers',
  templateUrl: './settings-drivers.component.html',
  styleUrls: ['./settings-drivers.component.css']
})
export class SettingsDriversComponent implements OnInit {

  config: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  driverName: string;
  mobileNumber: string;
  packageList: any = [];
  packageDelete: any;

  //driversList : any =[];
  constructor(private api: ApiIntegration, private http: HttpClient, private g: Globals) {
    this.g.page = "Driver Settings",
      this.getValues();
  }


  getValues() {
    this.api.getValues("1", "PACKAGE_TYPE", "PACKAGE_TYPE", "PACKAGE_TYPE").subscribe((data: any) => {
      this.packageList = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  /*  getDriversList() {
      this.api.getValues("1").subscribe((data:any)=> {
        this.driversList = data.tripleSetConfigDTOS;
      }, err=> {console.log(err);});
    }*/
  ngOnInit() {
  }


  /*
    submitDriver() {
      this.statusText2 = "";
      this.statusText3 = "";
      if (this.driverName == '' || this.driverName === null || this.driverName === undefined || this.driverName === 'undefined') {
        this.statusText2 = 'Please Enter Driver Name';
          }
      if (this.mobileNumber == '' || this.mobileNumber === null|| this.mobileNumber === undefined|| this.mobileNumber === 'undefined') {
        this.statusText3 = 'Please enter mobile number';
      }else if (this.mobileNumber.length != 10) {
        this.statusText3 = 'mobile number must be minimum 10 characters';
      }
      if (this.statusText2 != "" ||this.statusText3 != "" ) {
        return false;
      }
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
      this.http.post(environment.apiUrl + 'api/createShiftDrivers',{
          "driverName": this.driverName,
          "mobileNumber": this.mobileNumber,
          "status": "ACTIVE"
        },
        {headers: header1}).subscribe(data => {
          if(data['code'] == 200) {
            this.driverName = "";
            this.mobileNumber = "";
           // this.getDriverList();
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      )
    }
  */

  submitPackage() {
    this.statusText1 = "";
    if (this.config == '' || this.config === null || this.config === undefined || this.config === 'undefined') {
      this.statusText1 = 'Package should not be empty';
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTripleSetConfigs', {
      "child": "PACKAGE_TYPE",
      "config": this.config,
      "control": "PACKAGE_TYPE",
      "organizationId": 1,
      "parent": "PACKAGE_TYPE"
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
          this.config = "";
          this.getValues();
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      )
  }


  deletePackage() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteTripleSetConfig', {
      "id": this.packageDelete.id
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
          this.getValues();
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
  }

  selectedDeletePackage(r) {
    this.packageDelete = r;
  }

  /*
    changeStatus(n) {
      if (n.status == "ACTIVE") {
        n.status = "IN_ACTIVE";
      } else {
        n.status = "ACTIVE";
      }
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
      this.http.post(environment.apiUrl + 'api/updateStatus', {
        "id": n.id,
        "status": n.status
      }, {headers: header1}).subscribe(data => {
        },
        (err: HttpErrorResponse) => {
        });

    }
  */

}
